import { Partner } from "@/domain/entities/Partner"
import { PartnerListResponseDataDTO, PartnerListResponseDTO } from "../dto/PartnerListResponseDTO"
import { PartnerShowResponseDataDTO } from "../dto/PartnerShowResponseDTO"

const toDomainFromList = (data: PartnerListResponseDataDTO): Partner => {
    const contact = data.users[0]
    return {
        id: data.id,
        name: data.name,
        contact_email: contact.email,
        contact_name: contact.name,
        codes_count: data.codes_count,
        created_at: data.created_at,
        active: data.active,
    }
}
const toDomainFromShow = (data: PartnerShowResponseDataDTO): Partner => {
    const contact = data.partnership.users[0]
    return {
        id: data.partnership.id,
        name: data.partnership.name,
        contact_email: contact.email,
        contact_name: contact.name,
        codes_count: data.codes_count,
        created_at: data.partnership.created_at,
        active: data.partnership.active
    }
}
const toDomainList = (data: PartnerListResponseDataDTO[]): Partner[] => data.map(toDomainFromList)

export default { toDomainList, toDomainFromShow }
